import React from 'react';
import urlBase from '../../url-base';
import axios from 'axios';

import queryString from 'query-string';
import pdfResumoPropostaPF from '../../components/relatorio/resumo_proposta_pf';
import pdfResumoPropostaPJ from '../../components/relatorio/resumo_proposta_pj';


class ResumoPropostaPF extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      detailsDataPF: 'loading',
      companyData: 'loading'
    };


  }

  componentDidMount() {
    let param = queryString.parse(window.location.search);

    if (param.tipo == 'pf') {
      this.detailsPF(param.id);
    }
    if (param.tipo == 'pj') {
      this.detailsPJ(param.id);
    }    
      
  }
  /**
   * Busca as informações da empressa e prepara dados para geração do relatório
   * @param {*} companyId 
   */
  detailsPJ(companyId) {
    let url = urlBase.loopBack + 'Companies/getDocsByCompany';
    let state = this.state;
    let dataPostCompany = {
      id: companyId
    };


    axios.post(url, dataPostCompany)
    .then((response) => {

      state.companyData = response.data;


      if (state.companyData.planS4 != null || state.companyData.planS4 != undefined) {
            let dataPostPlano = {
              'codeS4': state.companyData.planS4
            };

            axios.get(urlBase.loopBack + 'Plans/findOne', dataPostPlano)
            .then((result) => {

              if (result.data != null) {
                state.companyData.plano = result.data.name;
              }
          })
          .catch(function (erro) {
            alert(erro);
          });          

      } 

      let dataPost = {
        'cep': state.companyData.cep
      };
      // Pega o endereço
      axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
      .then((result) => {
        if (result.data != null) {
                  state.companyData.bairro = result.data.Bairro;
                  state.companyData.municipio = result.data.Municipio;
                  state.companyData.estado= result.data.Uf;


        }
        this.setState(state);

        pdfResumoPropostaPJ(this.state.companyData, "download");                      

    })
    .catch(function (erro) {
      alert(erro);
    });      


        /*
      var municipio = state.cityList.find( lista => lista.Id === state.companyData.city );
      state.companyData.municipio = municipio.Nome;
  
      var estado = state.stateList.find( lista => lista.Id === state.companyData.state );
      state.companyData.estado = estado.Sigla;
  
      var bairro = state.districtList.find( lista => lista.Id === state.companyData.district );
      state.companyData.bairro = bairro.Nome;     
  
      var plano = state.plansPjListS4.find( lista => lista.codeS4 === state.companyData.planS4 );
      state.companyData.plano = plano.name; 
*/

 
   // VERIFICAR QUAIS INFORMAÇÕES ESTÃO AQUI NESTA FUNÇÃO 
    //  this.details();

    })
    .catch(function () {
      alert('Problema encontrado ao buscar a proposta ');
    }.bind(this));
  }

  /**
   * Busca as informações do cliente pessoa física e prepara dados para geração do relatório
   * @param {*} salesId 
   */
  detailsPF(salesId) {
    let dataPost = {
      salesId: salesId
    };
    let state = this.state;

    let url = urlBase.loopBack + 'Sales/getProposalDetails';
   
    axios.post(url, dataPost)
    .then((response) => {

      if (response.data.length == 0){
        state.detailsDataPF = 'zero';
      }else{
            state.detailsDataPF = response.data;
            let dataPost = {
              'cep': state.detailsDataPF.financialManager.cep
            };
            // Pega o endereço

            axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
            .then((result) => {
              if (result.data != null) {
                        state.detailsDataPF.financialManager.district = result.data.IdBairro;
                        state.detailsDataPF.financialManager.bairro = result.data.Bairro;
                        state.detailsDataPF.financialManager.municipio = result.data.Municipio;
                        state.detailsDataPF.financialManager.estado = result.data.Uf;
                        axios.get(urlBase.loopBack + 'FormOfPayments/' + state.detailsDataPF.financialManager.formOfPaymentId)
                        .then((response) => {
                          state.detailsDataPF.validity = response.data.validity;
                        })
                        .catch(function () {
                          alert('Erro ao buscar Forma de Pagamento');
                        });                        
                        pdfResumoPropostaPF(this.state.detailsDataPF, "download");

              }
          })
          .catch(function (erro) {
            alert(erro);
          });        
      }

      this.setState(state);
 
    })
    .catch(function () {
      let state = this.state;
      state.data = 'error';
      this.setState(state);
    }.bind(this));

  }  


  render() {
    return (
      <div> 
          <p>.</p>     
      </div>
    );

  }

}

export default ResumoPropostaPF;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/ResumoProposta.js
 **/